import { styled } from "@mui/material/styles";
import { Box, TableCell, TableContainer, Typography } from "@mui/material";

export const ListingTableLayout = styled(Box)`
  width: 100%;
  overflow: auto;
  box-shadow: none;
`;

export const ListingTableContainer = styled(TableContainer)`
  height: 578px;
  border: 1px solid lightgray;
`;

export const ListingTableCell = styled(TableCell)`
  padding: 5px 10px;
`;

export const PatientName = styled(Typography)`
  width: 250px;
  text-transform: capitalize;
`;
